let id = 0;

const defaultOptions = {
  type: 'success',
  position: 'bottom',
};

export default function createNotific(options: { type: string; msg: string }) {
  id += 1;
  return {
    ...defaultOptions,
    ...options,
    id,
  };
}
